const tutorialRoutes = [
  {
    path: "/tutorial",
    name: "TutorialContents",
    component: () => import("../views/tutorial/TutorialContents.vue"),
    meta: {
      icon: "mdi-school",
      localize: "tutorial.contents.title",
      requiresAuth: true
    }
  },
  {
    path: "/tutorial/statistics",
    name: "TutorialStatistics",
    component: () => import("../views/tutorial/TutorialStatistics.vue"),
    meta: {
      icon: "mdi-chart-box",
      localize: "tutorial.statistics.title",
      requiresAuth: true,
      requiresAdmin: true
    }
  }
];

export default tutorialRoutes;
